import { Provider } from '@angular/core';

import { CodesUseCasesImpl } from '@/use-cases/codes/codes.use-cases';
import { CODES_USE_CASES } from '@/use-cases/codes/codes.use-cases.contract';

export const codesUseCasesProvider: Provider = {
  provide: CODES_USE_CASES,
  useClass: CodesUseCasesImpl
};
